import React from "react";
//#region components
import { BulletList } from "components/common";
//#endregion
import { IconDefinitionConstants } from "utils/constants";

interface ImportProblemListProps {
  description: string;
  customers: string[];
}

const ImportProblemList: React.FC<ImportProblemListProps> = ({ description, customers }) => (
  <>
    {description}
    <BulletList items={customers} icon={IconDefinitionConstants.WArrowSmallRight} />
  </>
);

export default ImportProblemList;
